import React, { useState } from "react";
import { Card, Stack } from "@mantine/core";
import { PageProps } from "@sdflc/react-router-pages";

import { useAccounts } from "@/hooks";
import { Account } from "@/utils/api";

import { DashboardLayout } from "@/components/layouts";

import { AccountForm } from "@/components/features";

export const AccountSettingsPage: React.FC<PageProps> = (props: PageProps) => {
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const { lastError, clearError } = useAccounts({
    autoLoad: false, // AccountForm will handle loading the specific account
  });

  const handleSuccess = (updatedAccount: Account) => {
    clearError();
    setSuccessMessage(`Account "${updatedAccount.name}" updated successfully!`);

    // Clear success message after 3 seconds
    setTimeout(() => setSuccessMessage(null), 3000);
  };

  /*   const handleFormError = () => {
    setSuccessMessage(null);
  }; */

  // Clear success message when there's an error
  React.useEffect(() => {
    if (lastError) {
      setSuccessMessage(null);
    }
  }, [lastError]);

  return (
    <DashboardLayout {...props}>
      <Stack gap="lg">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <AccountForm
            onSuccess={handleSuccess}
            error={lastError}
            success={successMessage}
          />
        </Card>
      </Stack>
    </DashboardLayout>
  );
};
